// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1pgye","signatureButtonsRight":"ModalSign_signatureButtonsRight__26Tnr"};